<template>
  <div>
    <el-table
      :data="tableData"
      stripe
      height="280"
      :cell-style="{ padding: '3px' }"
      :header-cell-style="{ padding: '3px' }"
      style="width: 100%; font-size: 12px"
    >
      <el-table-column label="Brand" width="240" align="center">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="light"
            :visible-arrow="false"
            :content="scope.row.brandName"
            popper-class="tooltip-class"
            placement="top"
          >
            <div class="ellipsis">{{ scope.row.brandName }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="SKU" width="240" align="center">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="light"
            :visible-arrow="false"
            :content="scope.row.skuName"
            popper-class="tooltip-class"
            placement="top"
          >
            <div class="ellipsis">{{ scope.row.skuName }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="实际数量(标准)" width="120" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.oriQuantity | NumberFormat(false) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="拆分后数量(标准)" width="150" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.actualQuantity | NumberFormat(false) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="指标数量" width="120" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.targetQuantity | NumberFormat(false) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="金额达成率" width="90" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.yieldRate ? scope.row.yieldRate + '%' : '-' }}</div>
        </template>
      </el-table-column>
      <el-table-column label="拆分后金额" width="120" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.actualAmount | NumberFormat(false) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="指标金额" width="120" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.targetAmount | NumberFormat(false) }}</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      small
      layout="prev, pager, next, total"
      :total="total"
      :page-size="ipagination.pageSize"
      @current-change="handleTableChange"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => {}
    },
    ipagination: {
      type: Object,
      default: () => {}
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {}
  },
  mounted() {},
  watch: {},
  methods: {
    handleTableChange(pagination) {
      this.$emit('change', pagination)
    }
  }
}
</script>

<style lang="less" scoped>
.ellipsis {
  white-space: normal;
  word-break: break-all;
  line-height: 1.4;
}
</style>

<style lang="less">
.tooltip-class {
  font-size: 12px;
  color: #606266;
  border: 1px solid #fff !important;
  box-shadow: 0 0 5px #ccc;
}
</style>
